import type { CustomerSearchMatch } from "~/services/aiOrchestrator";

const pickJevCustomerSuggestions = (
	matches: readonly CustomerSearchMatch[],
	shownCustomerIds: readonly string[]
): CustomerSearchMatch[] => {
	const offeredTier = matches.some((match) => match.tier === "SUGGESTED") ? "SUGGESTED" : "CHECK";
	const seenCustomerIds = new Set(shownCustomerIds);
	return matches.filter((match) => {
		if (match.tier !== offeredTier || seenCustomerIds.has(match.customerId)) return false;
		seenCustomerIds.add(match.customerId);
		return true;
	});
};

export default pickJevCustomerSuggestions;
